import { magicNumbers } from 'utils';

export const twitterInitialState = {
  ageFilter: {
    isDisabled: true,
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'ageFilter',
    translateKey: 'filter:ageRange',
    hasActivateSwitch: true,
  },
  genderFilter: {
    isDisabled: true,
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'genderFilter',
    translateKey: 'filter:gender',
    hasActivateSwitch: true,
  },
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      content_count: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:contentCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
        toggler: 'switch',
      },
      follower_count: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:followerCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
        toggler: 'switch',
      },
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
        toggler: 'switch',
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:resourceBasedOn',
  },
  languageFilter: {
    title: 'filter:baseOnLanguage',
    isDisabled: true,
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
    hasActivateSwitch: true,
  },
  sortResourcesBy: {
    title: 'filter:sortBasedOnResult',
    hasFilter: false,
    isOpen: false,
    selected: 'follower_count',
    order: 'desc',
    platform: 'twitter',
    componentName: 'sortResourcesBy',
    translateKey: 'filter:resourceCategory',
  },
};
